<script setup>
import Web from '@/components/guest/guest.vue'
import Mobile from '@/components/guest/guest-mobile.vue'
const IS_Mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|HarmonyOS|OpenHarmony/i.test(navigator.userAgent);
const IS_H5 = IS_Mobile || window.innerWidth <= 768;
</script>
<template>
    <!-- /* 判读是从哪个入口进入 */ -->
    <Mobile v-if="IS_H5" />
    <Web v-else />
</template>
<style lang="scss" scoped></style>
